import Icon from '../components/Icon.vue'

Icon.register({"prescription":{"width":384,"height":512,"paths":[{"d":"M301.3 352L379.3 273.9C385.6 267.7 385.6 257.6 379.3 251.3L356.7 228.7C350.4 222.4 340.3 222.4 334.1 228.7L256 306.7 172 222.8C219.3 216.8 256 176.9 256 128 256 75 213 32 160 32H16C7.2 32 0 39.2 0 48V304C0 312.8 7.2 320 16 320H48C56.8 320 64 312.8 64 304V224H82.8L210.8 352 132.7 430.1C126.4 436.3 126.4 446.4 132.7 452.7L155.3 475.3C161.6 481.6 171.7 481.6 177.9 475.3L256 397.3 334.1 475.3C340.3 481.6 350.4 481.6 356.7 475.3L379.3 452.7C385.6 446.4 385.6 436.3 379.3 430.1L301.3 352zM64 96H160C177.6 96 192 110.4 192 128S177.6 160 160 160H64V96z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/prescription.js
// module id = null
// module chunks = 